import React from "react";
import {
  PieChart,
  Pie,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { normalizePieChartData } from "./chartData";

const DEFAULT_COLORS = [
  "#235B67",
  "#227E79",
  "#23A487",
  "#23C998",
  "#70D460",
  "#A3C854",
];

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize={12}
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

export default function PieChartCard({
  title,
  data,
  colors = DEFAULT_COLORS,
  height = 250,
}) {
  const chartData = normalizePieChartData(data);

  return (
    <div className="chartCard">
      <h3 className="chartCardTitle">{title}</h3>
      <div className="chartCardFigure" style={{ height }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={renderCustomizedLabel}
              outerRadius="80%"
              dataKey="value"
              nameKey="label"
            >
              {chartData.map((_, idx) => (
                <Cell key={idx} fill={colors[idx % colors.length]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <ul className="chartCardLegend" aria-label={`Referencias de ${title}`}>
        {chartData.map((entry, idx) => {
          const legendLabel = entry.label || entry.name || "";

          return (
            <li key={`${legendLabel}-${idx}`} className="chartCardLegendItem">
              <span
                className="chartCardLegendSwatch"
                style={{ backgroundColor: colors[idx % colors.length] }}
                aria-hidden="true"
              />
              <span className="chartCardLegendLabel">{legendLabel}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
